import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PassService {

  constructor(
    private http: HttpClient
  ) { }

  getPassForSale(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `/v2/tokens/for-sale?type=pass`);
  }
  getUserPasses(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `/v2/tokens/user-passes`);
  }
}
